import React, {Component} from 'react';

class Avatar extends Component {
    constructor(props) {
        super(props);
        this.state = {timestamp: (props.timestamp ? props.timestamp : 0)};

        this.forceRender = this.forceRender.bind(this);
        if(props.globalFuncName) {
            window[props.globalFuncName] = this.forceRender;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.timestamp !== this.props.timestamp) {
            this.setState({timestamp: this.props.timestamp})
        }
    }

    forceRender(timestamp = 0) {
        this.setState({timestamp})
    }

    render() {
        let tParam = '';
        if (this.state.timestamp > 0) {
            tParam = '&t='+this.state.timestamp;
        }
        return (<img className="round-avatar" src={bm_user_avatar_url+tParam } />);
    }
}

export default Avatar;